import { defineComponent as _defineComponent } from 'vue'
import OrdersListTile from "./OrdersListTile.vue";
  import Utils from "@/Utils";
  import Order from "@/model/Order";
  import {computed, ComputedRef, PropType} from "vue";
  import {OrderType} from "@/enums";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OrdersList',
  props: {
    icon: {
      type: String,
      default: "mdi-folder"
    },
    orders: {
      type: Array as PropType<Array<Order>>,
      default: () => new Array<Order>()
    }
  },
  emits: ["orderClicked"],
  setup(__props, { emit }) {

const props = __props

  

  const sortedGroups: ComputedRef<Map<OrderType, Array<Order>>> = computed(() => {
    const grouped = Utils.groupBy(props.orders, (item: Order) => item.orderType);

    const sorted = new Map();
    for (const orderType in OrderType) {
      const orderTypeEntries = grouped.get(orderType);
      if (orderTypeEntries && orderTypeEntries.length > 0) {
        sorted.set(orderType, orderTypeEntries);
      }
    }

    return sorted;
  });

  

  function openOrder(order: Order) {
    emit("orderClicked", order);
  }

return { __sfc: true,props, sortedGroups, emit, openOrder, OrdersListTile }
}

})